/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import "./App.scss";
import DefaultLayout from "./common/components/layout/Layout";
import { ToastContainer } from "react-toastify";
import { theme } from "theme/theme";
import ErrorBoundary from "features/errorBoundary";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import useDeviceDetection from "helpers/deviceDetector";
import MobileLayout from "common/components/layout/MobileLayout";
import { useLocation } from "react-router";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { saveDeviceType } from "slices/deviceDetection.slice";
import { QuickSightTimer } from "features/quickSightDashboard/interfaces/quickSightDashboard.interface";
import { RootState } from "store/store";
import endpoints from "api/endpoints";
// import { setQuickSightTimersAction } from "features/quickSightDashboard/slices/quickSightTimer.slice";
// import { createUSerSession } from "features/quickSightDashboard/actions/quickSightDashboard.action";

function App() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isMobileOrTablet = useDeviceDetection();
  const [isMobileOrTabletView, setIsMobileOrTabletView] = useState(false);
  const pageTimer: QuickSightTimer = useAppSelector((state: RootState) => state.quickSightTimer);

  useEffect(() => {
    window.addEventListener("beforeunload", async function (event) {
      const payload = { ...JSON.parse(localStorage.getItem("sessionsData1")) };
      const payloadFormated = {
        session_start_time: payload?.sessionStartTime,
        total_time: payload?.totalTime,
        hospital: payload?.hospital,
        hospital_system: payload?.hospitalsystem,
        hospital_by_state: payload?.hospitalbystate,
        legislator: payload?.legislator,
        clinical_categories: payload?.clinicalcategories,
        medications: payload?.medications,
        state_compare: payload?.statecompare,
        asc: payload?.asc,
        glossary: payload?.glossary,
      };

      const jsonData = JSON.stringify(payloadFormated);

      const requestOptions = {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: jsonData,
      };

      fetch(endpoints?.userSession?.resource, requestOptions);
      localStorage.setItem("sessionsData1", null);
    });
  }, []);

  // Device detection check hook
  useEffect(() => {
    const isMobileTablet = { isMobileTabletDevice: isMobileOrTablet };
    dispatch(saveDeviceType(isMobileTablet));
    setIsMobileOrTabletView(isMobileOrTablet);
  }, [isMobileOrTablet, location]);

  // Custom theme for all material components
  const theme = createTheme({
    typography: {
      allVariants: {
        fontFamily: "inter",
      },
    },
  });

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <React.Suspense>
          <ToastContainer />
          {isMobileOrTabletView ? (
            location.pathname === "/pricing" || location.pathname === "/preview-pricing" ? (
              <MobileLayout />
            ) : (
              <DefaultLayout />
            )
          ) : (
            <DefaultLayout />
          )}
        </React.Suspense>
        {/* Metadata for social sharing */}
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
